import { ILead } from 'src/interfaces/lead';
import { IMaintenancePackage } from 'src/interfaces/maintenancePackage';
import { IMake } from 'src/interfaces/make';
import { ISource } from 'src/interfaces/source';
import { IStatus } from 'src/interfaces/status';
import { IStore } from 'src/interfaces/store';
import { ISubstatus } from 'src/interfaces/substatus';
import { IUser } from 'src/interfaces/user';
import { IVehicle } from 'src/interfaces/vehicle';

type TItem =
    | string
    | Partial<IStore>
    | Partial<ISource>
    | Partial<IMaintenancePackage>
    | Partial<ILead>
    | Partial<IUser>
    | Partial<IMake>
    | Partial<IVehicle>
    | Partial<IStatus>
    | Partial<ISubstatus>;

/**
 * Will normalize the store to get the id of the collection
 *
 * @param {((string | Partial<IStore>)[])} stores
 * @return {*}  {string[]}
 */
export const getDocumentIdsFromArray = (items: (string | TItem)[]): string[] =>
    items.map((item) =>
        typeof item === 'string' ? item : item._id ? item._id : ''
    );
